import React from 'react';
import { useTranslation } from 'react-i18next';
import { ListColumnType } from 'types/ListTypes';
import AbstractList from 'components/lists/AbstractList';
import PriceIndexationForm from './PriceIndexationForm';

// Rename the name of the function:
const PriceIndexationList: React.FC = () => {
    const { t } = useTranslation();

    // Specify the columns of this list:
    const columns: ListColumnType[] = [
        {
            width: '1fr',
            field: 'year',
            label: 'billing.price_indexation.year_label',
        },
        {
            width: '1fr',
            field: 'percentage',
            label: 'billing.price_indexation.percentage_label',
            render: (_, row) => <span>{String(row.percentage).replace('.', ',')} %</span>
        },
        {
            width: '2fr',
            field: 'environment_name',
            label: 'billing.price_indexation.scope_label',
            render: (_, row) => <span>{row.environment_name || t('billing.price_indexation.all_customers_label')}</span>
        },
    ];

    return (
        <AbstractList
            query={{
                endpoint: 'get_price_indexation_list',
                object: 'price_indexation'
            }}
            objectName='billing.price_indexation.object_name'
            explanationText='billing.price_indexation.explanation'
            columns={columns}
            showSearch={false}
            showAddButton={true}
            isPaginated={false}
            formModal={<PriceIndexationForm />}
            onRowClick='editModal'
        />
    );
};

export default PriceIndexationList;
